<div class="brand-container d-sm-flex" [class.d-block]="isLandingPage">
  <a class="navbar-brand nav-brand-org" [href]="school?.schoolUrlLink">
    <img [src]="school?.navBarLogoUrl" />
  </a>
</div>
